import { useState } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { setCoverImages } from "../../redux/slice/sketchSlice";
import { setCoverImageUploadStatus } from "../../redux/slice/stepSlice";
import { MAX_DRAW_RETRIES, drawRetriesUsedUp, retryDrawing } from "../../services/drawRetryService";

/**
 * The failed cover's "Try again" (PhotosCoverFailed; also step 4 and Preview):
 * re-sends the stored photo through the API, so the cover goes back to
 * "drawing"; after the second failed try only "Change photo" is offered.
 * `onRetried` lets a screen with its own copy of the photos (Preview) refetch.
 */
export function useCoverRetry(bookId, cover, { onRetried } = {}) {
  const dispatch = useDispatch();
  const [retrying, setRetrying] = useState(false);
  const failed = !!cover && !(cover.AIUrl || cover.AIinfo?.aws_upload?.s3_url) && cover.drawStatus === "failed";

  const patchCover = (fields) =>
    dispatch((dispatch, getState) => {
      const current = getState().sketch.coverImages;
      dispatch(setCoverImages(current.map((c, i) => (i === 0 ? { ...c, ...fields } : c))));
    });

  const retry = async () => {
    if (retrying) return;
    setRetrying(true);
    const result = await retryDrawing({ bookId, cover: true });
    setRetrying(false);
    if (result.ok) {
      patchCover({ drawStatus: "drawing", drawRetries: (cover?.drawRetries || 0) + 1, AIUrl: null });
      dispatch(setCoverImageUploadStatus(true));
      onRetried?.();
    } else if (result.code === "RETRY_LIMIT") {
      patchCover({ drawRetries: MAX_DRAW_RETRIES });
    } else {
      toast.error(result.message || "We couldn't start that. Please try again.");
    }
  };

  return { failed, retry, retrying, usedUp: drawRetriesUsedUp(cover) };
}
